function deserialize(value, reviver) {
  return JSON.parse(value, (key, value_) => {
    var _value, _value2, _reviver;
    let value = value_;
    if (((_value = value) === null || _value === void 0 ? void 0 : _value.__type) === "bigint") value = BigInt(value.value);
    if (((_value2 = value) === null || _value2 === void 0 ? void 0 : _value2.__type) === "Map") value = new Map(value.value);
    return (_reviver = void 0 ) !== null && _reviver !== void 0 ? _reviver : value;
  });
}

export { deserialize };
